import FilterResults from '../FilterResults';

const TrainerReflectionFeedback = ({ role, hiddenFields, defaultFilters }) => {
  return (
    <FilterResults
      role={role}
      defaultFilters={defaultFilters}
      hiddenFields={hiddenFields}
      exportText={{
        active: 'Export Filtered Trainer Feedback',
        inactive: 'Export Trainer Feedback'
      }}
      hideApplyFiltersButton
      target={'trainerReflection'}
      isOpenedByDefault
      isOpened={false}
    />
  );
};

export default TrainerReflectionFeedback;
